import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1" });

export const OfficeService = {
  listDocuments: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/office/documents?${params.toString()}`);
  },

  uploadDocument: (data) => {
    return api.post(`/office/documents`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  deleteDocument: (documentId) => {
    return api.delete(`/office/documents/${documentId}`);
  },
};
